export default __webpack_public_path__ + "static/media/banner_desk_rosa_2.241b15f7.jpg";